"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaceBetSlipResultType = void 0;
var PlaceBetSlipResultType;
(function (PlaceBetSlipResultType) {
    PlaceBetSlipResultType[PlaceBetSlipResultType["Unknown"] = 0] = "Unknown";
    PlaceBetSlipResultType[PlaceBetSlipResultType["Ok"] = 1] = "Ok";
    PlaceBetSlipResultType[PlaceBetSlipResultType["BetSlipCheckFailed"] = 2] = "BetSlipCheckFailed";
    PlaceBetSlipResultType[PlaceBetSlipResultType["BetSlipNotSaved"] = 3] = "BetSlipNotSaved";
    PlaceBetSlipResultType[PlaceBetSlipResultType["AccountBookingFailed"] = 4] = "AccountBookingFailed";
    PlaceBetSlipResultType[PlaceBetSlipResultType["AccountHasInsufficientBalance"] = 5] = "AccountHasInsufficientBalance";
    PlaceBetSlipResultType[PlaceBetSlipResultType["BetSlipUpdateRiskFailed"] = 6] = "BetSlipUpdateRiskFailed";
    PlaceBetSlipResultType[PlaceBetSlipResultType["ExternalCheckFailed"] = 7] = "ExternalCheckFailed";
    PlaceBetSlipResultType[PlaceBetSlipResultType["BetPlacementNotAllowedInBranch"] = 8] = "BetPlacementNotAllowedInBranch";
    PlaceBetSlipResultType[PlaceBetSlipResultType["BetPlacementNotAllowedForUser"] = 9] = "BetPlacementNotAllowedForUser";
    PlaceBetSlipResultType[PlaceBetSlipResultType["BetRejectedByRiskRule"] = 10] = "BetRejectedByRiskRule";
    PlaceBetSlipResultType[PlaceBetSlipResultType["InvalidUserPin"] = 11] = "InvalidUserPin";
    PlaceBetSlipResultType[PlaceBetSlipResultType["InternalError"] = 99] = "InternalError";
})(PlaceBetSlipResultType = exports.PlaceBetSlipResultType || (exports.PlaceBetSlipResultType = {}));
